module.exports = __webpack_public_path__ + "static/img/bg_wdqb@2x.8f921602.png";